import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import moment from "moment";

import { FilterTypes } from "../constants";

import HttpClient from 'services/HttpClient';

const PERFORMANCE_API = '/api/v1/performances';
const SESSION_API = '/api/v1/sessions';

@withRouter
@inject("userStore")
@inject("alertStore")
@inject("mcqPerformanceStore")
@inject("mcqThemesStore")
@observer
export class PerformanceDetails extends Component {
  componentDidMount = () => {
    const {
      alertStore,
      mcqPerformanceStore,
      match,
    } = this.props;
    const id = match.params.sessionId;

    new HttpClient().get(`${PERFORMANCE_API}/${id}`)
    .then(({ body }) => {
      mcqPerformanceStore.setPerformance(body.data);
 
      new HttpClient().get(`${ SESSION_API }/${ id }`)
      .then(({ body }) => {
        mcqPerformanceStore.setPerformanceSession(body.data.session);
      })
      .catch(() => {
        alertStore.error('Something went wrong. Please try again.');
      });
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  };

  renderSession = () => {
    const { mcqPerformanceStore: { session }, mcqThemesStore: { mcq_themes } } = this.props;
    const themes = session.theme_ids.length === mcq_themes.length ?
      [{ id: 1, title: 'All categories specified' }] :
      mcq_themes.filter(theme => session.theme_ids.includes(theme.id));

    return (
      <div className="mcq-card mcq-card-row-between">
        <div className="mcq-card-text-wrapper">
          <span className="font-normal">{themes.map(theme => <span className="mx-8">{theme.title}</span>)}</span>
          <p className="font-normal">{`Start Date: ${moment(session.started_at).format('DD/MM/YYYY')}`}</p>
          <p className="font-normal">{FilterTypes[session.filter_type]}</p>
          <p className="font-normal opacity-70">{`Question ${session.answered_count} of ${session.mcq_question_count}`}</p>
        </div>
      </div>
    );
  };

  renderSlider = (correct, incorrect, total) => {
    const correctPercents = correct * 100 / total;
    const incorrectPercents = incorrect * 100 / total;

    return (
      <div className="performance-slider">
        <div className="performance-slider-line correct-line" style={{width: `${correctPercents}%`}} />
        <div className="performance-slider-line incorrect-line" style={{width: `${incorrectPercents}%`}} />
      </div>
    );
  };

  renderLegendProgress = () => {
    const { mcqPerformanceStore: { performance } } = this.props;

    return performance.session_id ? (
      <div className="performance-wrapper">
        <div className="performance-header">
          <h3>Legend Progress</h3>
          <div className="performance-instruction">
            <div className="performance-dots-wrapper">
              <div className="performance-dot correct" />
              <span>Correct answers</span>
            </div>
            <div className="performance-dots-wrapper">
              <div className="performance-dot incorrect" />
              <span>Incorrect answers</span>
            </div>
          </div>
        </div>
        <div className="mcq-card">
          {this.renderSlider(performance.legend.correct, performance.legend.incorrect, performance.legend.total_questions)}
        </div>
      </div>
    ) : null;
  };

  renderCategoryProgress = () => {
    const { mcqPerformanceStore: { performance } } = this.props;

    return performance.session_id ? (
      <div className="performance-wrapper">
        <div className="performance-header">
          <h3>Performance by Category</h3>
        </div>
        <div className="perforance-category-wrapper">
          {performance.performance_by_category.map((byCategory, index) => (
            <div key={`performance_by_category_${index}`} className="perforance-category">
              <span>{byCategory.theme}</span>
              <div className="mcq-card">
                <p className="categrory-calc">{`${byCategory.correct}/${byCategory.total}`}</p>
                {this.renderSlider(byCategory.correct, byCategory.incorrect, byCategory.total)}
              </div>
            </div>
          ))}
        </div>
      </div>
    ) : null;
  };

  render() {
    const { mcqPerformanceStore: { session } } = this.props;

    return (
      <div className="mcq-tab">
        <h3>Session Performance</h3>
        <div className="mcq-dashboard">
          {session.id ? this.renderSession() : null}
          {this.renderLegendProgress()}
          {this.renderCategoryProgress()}
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/mcq/containers/PerformanceDetails.js